import { TranscriptionScriptPDF } from '../../../report-pdf/components'

export { TranscriptionScriptPDF }
